<app-initial-form-table
  [form]="form"
  controlName=""
  [rows]="icfesQuestions"
  [columns]="icfesColumns">
</app-initial-form-table>